import { createSlice } from "@reduxjs/toolkit";
import ACTIONS from "./actions";

const initialState = {
  user: null,
  isLoggedIn: false,
  token: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    [ACTIONS.LOGOUT]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
    },
    [ACTIONS.REGISTER]: (state) => {
      state.isLoggedIn = false;
    },
    [ACTIONS.SET_USER]: (state, { payload }) => {
      state.isLoggedIn = true;
      state.user = payload;
      state.token = payload.token;
    },
  },
});
export const REDUCER = authSlice.actions;

export default authSlice.reducer;
